@if (loadingService.isLoading()) {
  <div class="app-loader-mask" role="status" aria-live="polite" aria-label="Loading">
    <div class="app-loader-card">
      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
      <span>Loading...</span>
    </div>
  </div>
}
